export const COMMENT_VISIBLE = 0;
export const COMMENT_HIDDEN_DELETED = 1;
export const COMMENT_HIDDEN_BANNED = 2;
export const COMMENT_HIDDEN_ARCHIVED = 3;
